module.exports = __webpack_public_path__ + "static/media/advertising-terms.en.ea4b1916.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/statsradio/modules/tutorials/assets/pdfs/follo/en/advertising-terms.en.pdf
// module id = ./src/statsradio/modules/tutorials/assets/pdfs/follo/en/advertising-terms.en.pdf
// module chunks = 18